/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  PayoutUnionpayCheckBinCodeResponse,
  PayoutUnionpayCheckBinCodeRequest
} from './schema'



export const utxPayoutUnionpayCheckBinCode = (
    payoutUnionpayCheckBinCodeRequest: PayoutUnionpayCheckBinCodeRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PayoutUnionpayCheckBinCodeResponse>> => {
    return axios.post(
      `/payout/unionpay/check-bin-code`,
      payoutUnionpayCheckBinCodeRequest,options
    );
  }



    export type UtxPayoutUnionpayCheckBinCodeMutationResult = NonNullable<Awaited<ReturnType<typeof utxPayoutUnionpayCheckBinCode>>>
    export type UtxPayoutUnionpayCheckBinCodeMutationBody = PayoutUnionpayCheckBinCodeRequest
    export type UtxPayoutUnionpayCheckBinCodeMutationError = AxiosError<void>

    export const useUtxPayoutUnionpayCheckBinCode = <TError = AxiosError<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxPayoutUnionpayCheckBinCode>>, TError,{data: PayoutUnionpayCheckBinCodeRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxPayoutUnionpayCheckBinCode>>, {data: PayoutUnionpayCheckBinCodeRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxPayoutUnionpayCheckBinCode(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxPayoutUnionpayCheckBinCode>>, TError, {data: PayoutUnionpayCheckBinCodeRequest}, TContext>(mutationFn, mutationOptions)
    }
    